import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { deactivateColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getDeactivate } from "../../../../api/sim";

const COPY_KEYS = ["id", "msisdn", "status", "created_at", "last_updated"];

const TmobilejDeactivateBatch = () => (
  <BatchDetail
    title="Deactivate"
    apiGet={__getDeactivate}
    client={CLIENTS.tmobilej}
    columnsFactory={deactivateColumns}
    copyKeys={COPY_KEYS}
    exportAction="deactivate"
    retryOperation="deactivate"
    showTerminate
    getRowPath={(row) => `/tmobilej/deactivate/${row.id}`}
  />
);

export default TmobilejDeactivateBatch;
